import _ from 'underscore';
import { useCallback, useState } from 'react';

export const useCampaignConversionGoalsAdapter = ({
  campaignId,
}) => {
  const [initialConversionGoals, setInitialConversionGoals] = useState([]);

  const mapToViewModel = useCallback((conversionGoals) => {
    const goals = _.map(conversionGoals, goal => ({
      id: String(goal.Id),
      name: goal.Name,
      TrackingStatus: goal.TrackingStatus,
      GoalCategory: goal.GoalCategory,
    }));

    setInitialConversionGoals(goals);

    return goals;
  }, [setInitialConversionGoals]);

  const mapToBulkModel = useCallback((conversionGoals) => {
    const goalsBefore = initialConversionGoals.map(goal => goal.id);
    const goalsAfter = conversionGoals.map(goal => goal.id);

    const goalsToAdd = _.difference(goalsAfter, goalsBefore);
    const goalsToDelete = _.difference(goalsBefore, goalsAfter);

    const targetsToAdd = _.chain(conversionGoals)
      .filter(goal => goalsToAdd.includes(goal.id))
      .map(goal => ({
        CampaignId: campaignId,
        Action: 'Add',
        GoalId: Number(goal.id),
        Name: goal.name,
        SubType: 'Goal',
      }))
      .value();

    const targetsToDelete = _.chain(initialConversionGoals)
      .filter(goal => goalsToDelete.includes(goal.id))
      .map(goal => ({
        CampaignId: campaignId,
        Action: 'Delete',
        GoalId: Number(goal.id),
        Name: goal.name,
        SubType: 'Goal',
      }))
      .value();

    return _.union(targetsToAdd, targetsToDelete);
  }, [campaignId, initialConversionGoals]);

  return {
    mapToViewModel,
    mapToBulkModel,
  };
};
